import { render } from "./index.vue?vue&type=template&id=3c365c16&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3c365c16&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c365c16"],['__file',"src/vab/components/VabBreadcrumb/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c365c16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c365c16', __exports__)) {
    console.log('reload')
    api.reload('3c365c16', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3c365c16&scoped=true", () => {
    console.log('re-render')
    api.rerender('3c365c16', render)
  })

}


export default __exports__